import React, { useRef } from 'react';
import Title from './Title.js';
import ShortButton from './ShortButton.js';
import { motion, AnimatePresence } from 'framer-motion';

const SettingTabs = ({ activeTab, setActiveTab, tabs }) => {
  // Use refs to prevent unnecessary re-renders
  const tabRefs = useRef(new Array(tabs.length));
  
  return (
    <div className="setting-tabs">
      <style>
        {`
          .setting-tabs {
            display: flex;
            gap: 16px;
            margin-bottom: 32px;
            will-change: transform; /* GPU hint */
          }
          
          .tab-item {
            cursor: pointer;
            display: flex;
            align-items: center;
            min-height: 40px;
            position: relative;
            transform: translateZ(0); /* Force GPU acceleration */
          }
          
          .tab-title {
            opacity: 0.8;
            transition: opacity 0.3s ease;
            padding: 8px 16px;
            display: flex;
          }
          
          .tab-title:hover {
            opacity: 1;
          }
        `}
      </style>
      
      {tabs.map((tab, index) => (
        <motion.div
          key={index}
          className="tab-item"
          onClick={() => setActiveTab(tab.value)}
          ref={el => tabRefs.current[index] = el}
          whileTap={{ scale: 0.97 }}
          transition={{ 
            type: "spring", 
            stiffness: 400, 
            damping: 17 
          }}
        >
          <AnimatePresence mode="wait" initial={false}>
            {activeTab === tab.value ? (
              <motion.div
                key="active"
                initial={{ y: 10, opacity: 0 }}
                animate={{ 
                  y: 0, 
                  opacity: 1,
                  transition: { 
                    type: "spring", 
                    stiffness: 500, 
                    damping: 25,
                    duration: 0.4
                  } 
                }}
                exit={{ 
                  y: -10, 
                  opacity: 0,
                  transition: { duration: 0.2 } 
                }}
              >
                <ShortButton 
                  text={tab.label} 
                  onClick={() => {}} 
                  type="button"
                />
              </motion.div>
            ) : (
              <motion.div 
                key="inactive"
                className="tab-title"
                initial={{ y: 10, opacity: 0 }}
                animate={{ 
                  y: 0, 
                  opacity: 0.9,
                  transition: { 
                    type: "spring", 
                    stiffness: 500, 
                    damping: 25,
                    duration: 0.4
                  } 
                }}
                exit={{ 
                  y: -10, 
                  opacity: 0,
                  transition: { duration: 0.2 } 
                }}
              >
                <Title text={tab.label} />
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      ))}
    </div>
  );
};

export default SettingTabs;